export default __webpack_public_path__ + "static/media/tmp_popup1.d8168947.png";